import { render } from "./_messages.vue?vue&type=template&id=3e192637&bindings={\"Close\":\"options\"}"
import script from "./_messages.vue?vue&type=script&lang=js"
export * from "./_messages.vue?vue&type=script&lang=js"
script.render = render

export default script